import { bodyVariantCSS, Button, Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

import { CardItem } from 'src/app/components/Elements/Card';
import { ToolTip } from 'src/app/components/Elements/ToolTip';
import { formatPrice } from 'src/app/utils';

export const TipContainer = styled.div`
  display: flex;
  flex-direction: row;
  text-transform: none !important;
  align-items: center;
`;

export const TipToolTip = styled(ToolTip)`
  /* top | right | bottom | left */
  margin: 0 0 0 1rem;
`;

export const EditTipButton = styled(Button)`
  margin-left: ${props => props.theme.space.s1};
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  text-transform: none !important;
  text-underline-offset: 2px !important;
  text-decoration: underline !important;
`;

export const SubmitTipButton = styled(Button)`
  padding: 0.5rem 1rem !important;
  height: ${props => props.theme.space.s6};
  margin-left: 2rem;
  text-transform: none !important;

  ${props => props.theme.mediaQueries.smallDown} {
    right: ${props => props.theme.space.s5};
    position: absolute;
  }
`;

export const GreenText = styled(Typography)`
  color: ${props => props.theme.colors.capsuleGreen60} !important;
  text-transform: none !important;
`;

export const ErrorText = styled(Typography)`
  color: ${props => props.theme.colors.capsuleRed60} !important;
  text-transform: none !important;
  margin-top: ${props => props.theme.space.s2};
`;

export const ActiveEditingContainer = styled.div``;

export const InnerActiveEditingContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${props => props.theme.space.s3};
`;

export const CurrencyTextInputContainer = styled.div`
  position: relative;
  width: ${props => props.theme.space.s8} !important;
  display: flex;
  align-items: flex-end;
`;

export const DollarSignLabel = styled(Typography)`
  position: absolute;
  color: ${props => props.theme.colors.capsuleGreen60} !important;
  padding-bottom: 1.3rem;
`;

export const CurrencyTextInput = styled.input`
  border: none;
  border-bottom: 1px solid ${props => props.theme.colors.capsuleGreen60};
  outline: none;
  width: ${props => props.theme.space.s8};
  ${props => props.theme.mediaQueries.smallDown} {
    width: unset;
  }

  ${bodyVariantCSS}
  color: ${props => props.theme.colors.capsuleBlue50};
  padding-left: ${props => props.theme.space.s5};
  padding-bottom: ${props => props.theme.space.s3};
  /* Disables the arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
  &[type='number'] {
    appearance: textfield;
  }
`;

export const SpacedOutCardItem = styled(CardItem)`
  display: flex !important;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${props => props.theme.colors.capsuleBlue50};
`;

export const HorizontalBar = styled.div`
  height: ${props => props.theme.space['0.1']};
  width: ${props => props.theme.space.s4};
  background-color: ${props => props.theme.colors.capsuleGray50} !important;
`;

export const PriceLabel = styled.span<{ isCrossedOut?: boolean }>`
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.roman};
  line-height: ${props => props.theme.fontSizes.small};
  letter-spacing: ${props => props.theme.letterSpacings.one};
  padding-right: ${props => props.theme.space.s3};
  color: ${props => (props.isCrossedOut ? props.theme.colors.capsuleGray50 : props.theme.colors.capsuleBlue50)};
  text-decoration: ${props => (props.isCrossedOut ? 'line-through' : 'none')};
`;

export const CardItemWithoutBottomPadding = styled(SpacedOutCardItem)`
  padding-bottom: 0 !important;
`;

export const TotalCostCardItem = ({ total, isDisabled }: { total: number; isDisabled: boolean }) => (
  <SpacedOutCardItem inactive={isDisabled} noDivider>
    <GreenText variant={'bodyHeader'}>TOTAL</GreenText>
    {isDisabled ? <HorizontalBar /> : <Typography variant={'body'}>{formatPrice(total)}</Typography>}
  </SpacedOutCardItem>
);
